import { toast } from "sonner";
import request from "../../../helpers/request";

export interface ILojaData {
  id: number;
  idCoordenacao: number;
  idRegional: number;
  idSeguradora: number;
  idDivisao?: number;
  importanciaSegurada: number;
  numero: string;
  nome: string;
  latitude?: string;
  longitude?: string;
  endereco: string;
  uf: string;
  ativo: boolean | number;
  arquivoPlanta?: string;
  cnpj?: string;
  vigencia?: string | Date | number;
}

export const getLoja = async (id: number) => {
  const url = `/Loja/${id}`;
  const response = await request({
    url,
    method: "GET",
  });
  console.log("response getLoja", response);
  return response;
};

export const updateLoja = async (dataRequest: ILojaData) => {
  const url = `/Loja/${dataRequest.id}`;

  const payload = {
    ...dataRequest,
    id: Number(dataRequest.id),
    importanciaSegurada: Number(dataRequest.importanciaSegurada),
    idCoordenacao: Number(dataRequest.idCoordenacao),
    idRegional: Number(dataRequest.idRegional),
    idSeguradora: Number(dataRequest.idSeguradora),

    latitude: dataRequest.latitude ? Number(dataRequest.latitude) : null,
    longitude: dataRequest.longitude ? Number(dataRequest.longitude) : null,
    ativo: Number(dataRequest.ativo),
  };

  console.log("updateLoja payload", payload);

  try {
    const { data } = await request({
      url,
      method: "PUT",
      data: payload,
    });

    console.log("updateLoja", data);

    const isSuccess =
      data === "ok" || (typeof data === "object" && data?.message === "ok");

    if (isSuccess) {
      console.log("Loja atualizada com sucesso, data:", data);
      return data;
    } else {
      console.error("Erro ao atualizar loja:", data);
      throw new Error(typeof data === "string" ? data : "Erro desconhecido");
    }
  } catch (error: any) {
    console.error("Erro ao atualizar loja:", error);

    let errorMessage =
      error.response?.data || error.message || "Erro ao atualizar";

    if (
      typeof errorMessage === "string" &&
      errorMessage.startsWith("Erro - ")
    ) {
      errorMessage = errorMessage.replace("Erro - ", "");
    }

    throw new Error(errorMessage);
  }
};

export const deleteLoja = async (id: number) => {
  const url = `/Loja/${id}`;
  const { data } = await request({ url, method: "DELETE" });

  if (data === "ok") {
    toast.success("Loja excluída com sucesso");
    return data;
  } else {
    let errorMessage =
      typeof data === "string" ? data.trim() : "Erro ao excluir";
    if (errorMessage.startsWith("Erro - ")) {
      errorMessage = errorMessage.replace("Erro - ", "");
    }
    toast.error(errorMessage);
    throw new Error(errorMessage);
  }
};

export default updateLoja;
